"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.bradford.description': 'Narrador británico, expresivo y cautivador.',
};
